import React, { memo } from 'react';

import './LandingPageNavbar.scss';
import { Link } from 'react-router-dom';
import logo from 'images/logo.png';
import Avatar from '../common/Avatar';
import DefaultCountrySelectBox from '../Sidebar/DefaultCountrySelectBox';

const LandingPageNavbar = () => (
  <div className="LandingPageNavbar">
    <div className="LandingPageBrandBar">
      <div className="LandingPageNavbar__side">
        <Avatar />
      </div>
      <div className="LandingPageNavbar__side">
        <DefaultCountrySelectBox />
        <Link to="/landing-page">
          <img className="LandingPageBrandBar__logo" src={logo} alt="" />
        </Link>
      </div>
    </div>
  </div>
);

export default memo(LandingPageNavbar);
